<template>
  <Teleport to="body">
    <div
      v-if="cardStatus"
      class="fixed right-6 z-bulk-import-toast"
      :class="hasProgressToastBelow ? 'bottom-48' : 'bottom-6'"
    >
      <BulkExportToastCard
        :status="cardStatus"
        :title="title"
        :description="description"
        :close-label="t('corp.bulk_import.toast.btn_close')"
        :download-label="t('corp.bulk_import.export_toast.download')"
        :progress="exportToastProgress"
        :remaining-label="t('corp.bulk_import.export_toast.remaining', { seconds: exportToastRemainingSeconds })"
        @close="bulkImportStore.dismissExportToast"
        @download="bulkImportStore.downloadExportedFile"
      />
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'

import { useBulkImportStore } from '@/stores/bulkImport'
import { useActiveBulkImportsStore } from '@/stores/activeBulkImports'
import BulkExportToastCard from './BulkExportToastCard.vue'

const { t } = useI18n()
const bulkImportStore = useBulkImportStore()
const activeBulkImportsStore = useActiveBulkImportsStore()

const {
  exportToastStatus,
  exportToastEntity,
  exportToastProgress,
  exportToastRemainingSeconds,
} = storeToRefs(bulkImportStore)

const cardStatus = computed(() =>
  exportToastStatus.value === 'idle' ? null : exportToastStatus.value,
)

const title = computed(() => {
  if (exportToastStatus.value === 'preparing') return t('corp.bulk_import.export_toast.title_preparing')
  if (exportToastStatus.value === 'downloaded') return t('corp.bulk_import.export_toast.title_downloaded')
  if (exportToastStatus.value === 'error') return t('corp.bulk_import.export_toast.title_error')
  return t('corp.bulk_import.export_toast.title_finalized')
})

const description = computed(() => {
  const entitySuffix = exportToastEntity.value
  if (exportToastStatus.value === 'preparing') {
    return t(`corp.bulk_import.export_toast.description_preparing_${entitySuffix}`)
  }
  if (exportToastStatus.value === 'downloaded') {
    return t(`corp.bulk_import.export_toast.description_downloaded_${entitySuffix}`)
  }
  if (exportToastStatus.value === 'error') {
    return t(`corp.bulk_import.export_toast.description_error_${entitySuffix}`)
  }
  return t('corp.bulk_import.export_toast.description_finalized')
})

const hasProgressToastBelow = computed(() =>
  activeBulkImportsStore.imports.some(
    (item) => !item.dismissed && !(bulkImportStore.drawerOpen && item.id === bulkImportStore.currentImport?.id),
  ),
)
</script>
